// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__eqeY+","button":"Form_button__mwPDx"};